{
  "app": {
    "title": "Menyu"
  },
  "common": {
    "close": "Yopish",
    "currency": "so'm",
    "from": "dan",
    "total": "Jami",
    "retry": "Qayta urinish",
    "clear": "Tozalash"
  },
  "menu": {
    "allTab": "Barcha taomlar",
    "defaultTitle": "Menyu",
    "searchLabel": "Menyu bo'yicha qidiruv",
    "searchPlaceholder": "Taomlarni qidirish…",
    "searchClear": "Qidiruvni tozalash",
    "searchHeading": "Natijalar",
    "noResults": "Hech narsa topilmadi",
    "emptyCategory": "Bu turkumda hozircha hech narsa yo'q...",
    "emptySearch": "So'rov bo'yicha hech narsa topilmadi",
    "error": "Menyuni yuklab bo'lmadi",
    "choose": "Tanlash",
    "add": "Qo'shish",
    "openPhoto": "Rasmni ochish: {{name}}",
    "addOne": "Bitta qo'shish: {{name}}",
    "removeOne": "Bittasini olib tashlash: {{name}}",
    "addons": "qo'shimchalar",
    "detailsAria": "Variantlar va qo'shimchalar: {{name}}",
    "layoutToGrid": "Katakcha ko'rinishiga o'tish",
    "layoutToList": "Ro'yxat ko'rinishiga o'tish",
    "categoriesNav": "Menyu turkumlari",
    "promoTab": "Aksiyalar",
    "promoBadge": "−{{n}}%",
    "promoBadgeUpTo": "−{{n}}% gacha",
    "promoAria": "Chegirma {{badge}}, narxi {{price}}",
    "positions": {
      "other": "taom"
    },
    "results": {
      "other": "natija"
    },
    "variants": {
      "other": "variant"
    }
  },
  "header": {
    "info": "Muassasa haqida ma'lumot",
    "yourTable": "Sizning stolingiz:",
    "quickActions": "Tezkor amallar",
    "callWaiter": "Ofitsiantni chaqirish",
    "bill": "Hisob",
    "cartAria": "Savat: {{count}}, {{total}} {{currency}}"
  },
  "banners": {
    "label": "Aksiya va takliflar",
    "role": "karusel",
    "slideRole": "slayd",
    "slide": "{{total}} tadan {{n}}",
    "pause": "Bannerlarni avtomatik almashtirishni to'xtatish",
    "play": "Bannerlarni avtomatik almashtirishni yoqish"
  },
  "item": {
    "variants": "Variantlar",
    "required": "Majburiy",
    "chooseGroup": "Tanlang: {{name}}",
    "upTo": "{{n}} tagacha",
    "limit": "chegara",
    "groupHint": "«{{name}}»: {{hint}}"
  },
  "cart": {
    "title": "Savat",
    "overline": "Buyurtmangiz",
    "submit": "Buyurtma berish",
    "sending": "Yuborilmoqda…",
    "added": "Buyurtmaga qo'shildi",
    "created": "Buyurtma ofitsiantga yuborildi",
    "ordersRetry": "Buyurtmalarni tekshirib bo'lmadi — qayta urinish",
    "sendError": "Buyurtmani yuborib bo'lmadi",
    "retryInfo": "Yuborib bo'lmadi — bir necha soniyadan keyin qayta urinib ko'ring",
    "clearedOnBill": "Savat tozalandi",
    "pickOrder": "Qaysi buyurtmaga qo'shilsin?",
    "max30": "Bitta so'rovda 30 tadan ortiq taom bo'lmasligi kerak",
    "comment": "Izoh",
    "commentPlaceholder": "Masalan: piyozsiz",
    "commentFilled": ", to'ldirilgan",
    "charsLeft": "{{n}} ta belgi qoldi",
    "orderNo": "Buyurtma №"
  },
  "bill": {
    "title": "Hisob",
    "overline": "Sizning stolingiz",
    "empty": "Hozircha faol buyurtmalar yo'q",
    "loading": "Buyurtmalar yuklanmoqda…",
    "error": "Buyurtmalarni yuklab bo'lmadi",
    "request": "Hisobni so'rash",
    "requested": "Hisob so'raldi…",
    "coming": "Ofitsiant hisobni olib kelmoqda",
    "alreadyRequested": "Hisob allaqachon so'ralgan, biroz kuting",
    "requestError": "Hisobni so'rab bo'lmadi",
    "payWith": {
      "CLICK": "CLICK orqali to'lash",
      "PAYME": "Payme orqali to'lash"
    },
    "payOpening": "To'lov ochilmoqda…",
    "payError": "To'lovni ochib bo'lmadi. Qayta urinib ko'ring",
    "itemPending": "Tasdiqlash kutilmoqda",
    "itemCancelled": "Bekor qilingan",
    "itemsConfirmed": "Taomlar ofitsiant tomonidan tasdiqlandi",
    "ordersList": "Buyurtmalar ro'yxati",
    "guests": "Mehmonlar",
    "waiter": "Ofitsiant",
    "serviceFee": "Xizmat haqi",
    "discount": "Chegirma"
  },
  "waiter": {
    "called": "Ofitsiant chaqirildi",
    "alreadyCalled": "Ofitsiant allaqachon chaqirilgan, biroz kuting",
    "error": "Ofitsiantni chaqirib bo'lmadi",
    "noOrder": "Ofitsiantni stolda buyurtma bo'lganda chaqirish mumkin",
    "noWaiter": "Buyurtmaga hali ofitsiant biriktirilmagan",
    "pickOrder": "Buyurtmani tanlang — uning ofitsianti keladi",
    "unassigned": "Ofitsiant biriktirilmagan"
  },
  "status": {
    "CREATED": "Yaratildi",
    "PENDING_APPROVAL": "Tasdiqlash kutilmoqda",
    "NEW": "Yangi",
    "ACCEPTED": "Qabul qilindi",
    "CONFIRMED": "Qabul qilindi",
    "IN_PROGRESS": "Tayyorlanmoqda",
    "COOKING": "Tayyorlanmoqda",
    "PREPARING": "Tayyorlanmoqda",
    "READY": "Tayyor",
    "SERVED": "Berildi",
    "DONE": "Tayyor",
    "COMPLETED": "Tayyor",
    "CANCELLED": "Bekor qilindi",
    "CANCELED": "Bekor qilindi"
  },
  "info": {
    "overline": "Muassasa",
    "title": "Ma'lumot",
    "copied": "Nusxalandi",
    "wifiSection": "Wi-Fi",
    "wifiName": "Wi-Fi tarmog'i",
    "copyWifiName": "Tarmoq nomidan nusxa olish",
    "password": "Parol",
    "copyPassword": "Paroldan nusxa olish",
    "phone": "Telefon",
    "address": "Manzil",
    "socials": "Ijtimoiy tarmoqlar"
  },
  "notFound": {
    "title": "Menyu topilmadi",
    "hint": "QR-kod to'g'riligini tekshiring yoki ofitsiantga murojaat qiling."
  },
  "viewer": {
    "title": "Rasmni ko'rish",
    "close": "Ko'rishni yopish"
  },
  "toast": {
    "dismiss": "Yopish uchun bosing."
  },
  "lang": {
    "label": "Til / Язык",
    "uz": "UZ — O'zbekcha",
    "ru": "РУ — Русский"
  }
}
